import CatalogoSimulado3D from "./CatalogoSimulado3D";

const ShowcaseSection = () => {
  return (
    <section className="text-center py-24">
      <h3 className="text-sm font-semibold leading-6 text-gray-700 tracking-wide uppercase">
        Um novo jeito de vender
      </h3>
      <h2 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
        Sua loja, mais digital. Seu atendimento, mais humano.
      </h2>
      <div className="mt-14">
        <CatalogoSimulado3D />
      </div>
    </section>
  );
};

export default ShowcaseSection;
